import { isBuildStarted, PublicApiBuild } from '@/models/Build';
import BuildStatus from '@/models/BuildStatus';
import { BaseRunnableDataMapper } from '@/utils/BaseRunnableDataMapper';
import { snakeCaseKeys } from '@/utils/changeCase';

class BuildDetailsDataMapper extends BaseRunnableDataMapper<PublicApiBuild> {
  isAborted(build: PublicApiBuild): boolean {
    return build.status === BuildStatus.Aborted || build.status === BuildStatus.AbortedWithSuccess;
  }

  protected getDurationStartedAt(build: PublicApiBuild): Date | undefined {
    return build.startedOnWorkerAt ? new Date(build.startedOnWorkerAt) : undefined;
  }

  protected isRunnableStarted(build: PublicApiBuild): boolean {
    return isBuildStarted(build);
  }

  getParameters(build: PublicApiBuild): string {
    return JSON.stringify(snakeCaseKeys(build.originalBuildParams), null, 2);
  }

  getUtilityBuildStatus(build: PublicApiBuild): string {
    if (!build.finishedAt) {
      return 'Not evaluated yet';
    }

    return build.utility ? 'Qualified' : 'Not qualified';
  }

  getUtilityBuildTooltip(build: PublicApiBuild): string {
    if (!build.finishedAt) {
      return "Utility build status is evaluated when the build finishes. If it qualifies, it won't use up one of your plan's monthly builds.";
    }

    return build.utility
      ? "Qualified as a Utility build, so it didn't use up one of your plan's monthly builds."
      : "Didn't qualify as a Utility build, so it used up one of your plan's monthly builds.";
  }

  protected getCommitMessage(build: PublicApiBuild): string | undefined {
    return build.commitMessage;
  }

  protected getPullRequestId(build: PublicApiBuild): number | undefined {
    return build.pullRequestId;
  }

  protected getTag(build: PublicApiBuild): string | undefined {
    return build.tag;
  }
}

export const buildMapperInstance = new BuildDetailsDataMapper();
